import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { OperacaoCreditoLivre } from 'src/app/model/operacao-credito-livre.model';
import { OperacaoGarantida,TIPO_ESTADO } from 'src/app/model/operacao-garantida.model';
import { OperacaoRepasseBndes } from 'src/app/model/operacao-repasse-bndes.model';
import { PermissaoService } from 'src/app/shared/permissao.service';


@Component({
    selector: 'app-operacao-listagem',
    templateUrl: './operacao-listagem.component.html',
    styleUrls: ['./operacao-listagem.component.scss'],
    standalone: false
})
export class OperacaoListagemComponent implements OnInit, OnChanges {

  @Input() private operacoes: OperacaoGarantida[];
  @Input() private agentesFinanceiros;
  @Input() private ehAgenteFinanceiro: boolean;


  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public exportarAditivos: EventEmitter<any> = new EventEmitter<any>();
  @Output() public exportarOperacoes: EventEmitter<any> = new EventEmitter<any>();
  @Output() public exportarLiberacoes: EventEmitter<any> = new EventEmitter<any>();
  @Output() public exportarAmortizacoes: EventEmitter<any> = new EventEmitter<any>();
  @Output() public mudarOrdenacao = new EventEmitter<EntityOrderedRequestParameters>();
  
  private _array = Array;
  private cnpjUsuario: string;
  private podeEscolherAgente = false;

  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  public opcoesPaginacao: number[] = [10, 15, 20, 50, 100];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  public operacoesPaginadas: OperacaoGarantida[];
  private operacoesTemp: OperacaoGarantida[];
  private tipoEstado = TIPO_ESTADO;
  private dataHoraResultado;

  constructor(
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService) { }

  ngOnInit() {

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
    });

    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario && usuario.cnpj;
    });
    this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');

    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  ngOnChanges() {
    this.operacoes.map(operacao => operacao.id = Number.parseInt(operacao.id.toString(), 10));
    this.pesquisar(this.atributosPaginacao);
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  pesquisar(pesq: EntityPagedRequestParameters) {
    this.operacoesTemp = this.operacoes;
    this.operacoesPaginadas = this.operacoesTemp.slice(0, pesq.pageSize);
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    console.log(novaOrdenacao);
    this.atributosOrdenacao = novaOrdenacao;
//    this.pesquisarOrdenacao(this.atributosOrdenacao);    A ordenação será feita sempre no backend
    this.mudarOrdenacao.emit(novaOrdenacao);

  }

  private compara(a, b, atributo): number {
    let va = this.fetchFromObject(a, atributo);
    let vb = this.fetchFromObject(b, atributo);

    if (atributo == 'detalhe.valorCredito') {
      va = Number(va);
      vb = Number(vb);
    }
  
    if (va == vb) {
      return 0;
    }

    return va > vb ? 1 : -1;
  }

  private getIdExternoOperacao(operacao: OperacaoGarantida) {
    return operacao.codigoTipoOperacao == 'L' ? (<OperacaoCreditoLivre>operacao).idOperacaoAgente : (<OperacaoRepasseBndes>operacao).idProtocoloBNDES;
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    if (prop == "idExternoOperacao") {
      return this.getIdExternoOperacao(obj);
    }

    var _index = prop.indexOf('.')
    if (_index > -1) {
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.operacoesPaginadas = this.operacoesPaginadas.sort((a, b) => {
      if (ord.sentido == "asc") {
        return this.compara(a, b, ord.atributo);
      }
      else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  isNumeric(str) {
    const er = /^[0-9]+$/;
    return (er.test(str));
  }

  btnExportarAditivos() {
    this.exportarAditivos.emit(null);
  }

  btnExportarOperacoes() {
    this.exportarOperacoes.emit(null);
  }

  btnExportarLiberacoes() {
    this.exportarLiberacoes.emit(null);
  }

  btnExportarAmortizacoes() {
    this.exportarAmortizacoes.emit(null);
  }

}
